import { useEffect, useState } from "react";
import { Badge, Dropdown, Form, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import DeleteModal from "../../../../common/DeleteModal";
import { Translate } from "../../../../Enums/Tranlate";

const CardItem = ({ item, index }) => {
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.admin?.admin_roles?.includes(data);
	const lang = useSelector((state) => state.auth?.lang);
	const [branchesModal, setBranchesModal] = useState(false);
	const branches = item?.branches ?? [];
	const visibleBranches = branches.slice(0, 2);
	const extraCount = branches.length - visibleBranches.length;
	const clockInBranch = item?.branchName;
	const clockOutBranch = item?.clockOutBranchName;

	const statusVariant = {
		PRESENT: "success",
		ABSENT: "danger",
		SICK_LEAVE: "warning",
		VACATION: "info",
		EMERGENCY: "dark",
	};

	const extractTime = (isoString) => {
		const date = new Date(isoString);

		return date.toLocaleTimeString("en-US", {
			hour: "2-digit",
			minute: "2-digit",
			hour12: true,
		});
	};

	return (
		<tr key={index}>
			<td className="text-nowrap">
				<strong>{item?.employeeId}</strong>
			</td>
			<td className="text-nowrap">{`${item?.employeeName}`}</td>
			<td className="text-nowrap">{item?.companyEmail}</td>
			<td>
				<div className="d-flex flex-wrap align-items-center" style={{ gap: 8 }}>
					{visibleBranches.map((res, i) => (
						<Badge key={i} variant="outline-primary">
							{res?.branchName?.[lang]}
						</Badge>
					))}
					{extraCount > 0 && (
						<Badge
							variant="primary"
							style={{ cursor: "pointer" }}
							onClick={() => setBranchesModal(true)}>
							+{extraCount}
						</Badge>
					)}
				</div>
				<Modal
					show={branchesModal}
					onHide={() => setBranchesModal(false)}
					centered>
					<Modal.Header closeButton>
						<Modal.Title>{Translate[lang]?.branch}</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div className="d-flex flex-wrap" style={{ gap: 8 }}>
							{branches.map((res, i) => (
								<Badge key={i} variant="outline-primary">
									{res?.branchName?.[lang]}
								</Badge>
							))}
						</div>
					</Modal.Body>
				</Modal>
			</td>
			<td className="text-nowrap">{item?.date}</td>
			<td className="text-nowrap text-center">
				{!!item?.clockInTime ? extractTime(item?.clockInTime) : "N/A"}
			</td>
			<td className="text-nowrap text-center">
				{!!item?.clockOutTime ? extractTime(item?.clockOutTime) : "N/A"}
			</td>
			<td className="text-nowrap">
				{clockInBranch?.[lang] ?? "-"}
			</td>
			<td className="text-nowrap">
				{clockOutBranch?.[lang] ?? "-"}
			</td>
			<td className="text-nowrap">{item?.lateMinutes}</td>
			<td className="text-nowrap">{item?.overtimeMinutes}</td>
			<td className="text-nowrap">{item?.earlyLeavingMinutes}</td>
			<td>
				<Badge variant={statusVariant[item?.status] ?? "danger"}>
					{Translate[lang]?.[item?.status?.toLowerCase()] ?? item?.status}
				</Badge>
			</td>

			{/* <td>
				<Dropdown>
					<Dropdown.Toggle className="light sharp i-false">
						<i className="la la-ellipsis-v" style={{ fontSize: "27px" }}></i>
					</Dropdown.Toggle>
					<Dropdown.Menu>
						<Dropdown.Item
							onClick={() =>
								navigate(`/edit-admin/${item.id}/${item?.f_name}`, {
									state: { edit: true, id: item.id, item: item },
								})
							}>
							<i className="la la-edit"></i> {Translate[lang]?.edit}
						</Dropdown.Item>
						<Dropdown.Item onClick={() => setDeleteModal(true)}>
							<i className="la la-trash"></i> {Translate[lang]?.delete}
						</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>
			</td> */}
		</tr>
	);
};
export default CardItem;
